import { Component, ChangeDetectorRef } from '@angular/core';
import { RestService } from '../../services/rest/rest.service';
import { GenericResponse } from '../../interfaces/apiresponses';
import { AuthService } from '../../services/auth/auth.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss']
})
export class ChangepasswordComponent {
  bLoading = false
  customStylesValidated = false

  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any

  closeAlert(event: any){

  }

  alertVisibility(event: any)
  {
    this.bAlert = event.state
  }

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {})
  {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any){
    this.bAlert = event.state
  }

  constructor(private service: RestService, private auth: AuthService, private route: Router, private changeDetector: ChangeDetectorRef) {}

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  forgotPasswordForm = new FormGroup(
    {
      password_1: new FormControl(),
      password_2: new FormControl()
    }
  )

  get password_1() { return this.forgotPasswordForm.get('password_1') }
  get password_2() { return this.forgotPasswordForm.get('password_2') }

  changePassword()
  {
    if (this.password_1?.value == undefined || this.password_1?.value === null || this.password_1?.value === '') {
      this.showAlertBox('Sorry', 'Blank passwords are not allowed')
      return 
    }

    if (this.password_1?.value !== this.password_2?.value) {
      this.showAlertBox('Sorry', 'Both the passwords are not matching')
      return
    }

    this.bLoading = true
    
    this.service.changePortalUserPassword(this.password_1?.value).subscribe({
      next: (v: GenericResponse) => {
        if (v.success) {
          this.route.navigate(['home'])
        } else {
          this.bLoading = false
          this.showAlertBox('Sorry', 'There is a technical error. Please try after some time')  
        }
      },
      error: (e) => {
        this.bLoading = false
        this.showAlertBox('Sorry', 'There is a technical error. Please try after some time')
      }
    })
  }
}
